import { cn } from '@/shared/lib/utils';
import { ElementType, HTMLAttributes } from 'react';

interface TypographyProps extends HTMLAttributes<HTMLElement> {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p' | 'caption';
}

const VARIANT_STYLES = {
  h1: 'h1 text-[20px]',
  h2: 'h2 text-[20pxrem]',
  h3: 'h3 text-[18px]',
  h4: 'h4 text-[16px]',
  h5: 'h5 text-[14px]',
  p: ' w-fit',
  caption: 'text-[10px] leading-none w-fit',
};

const VARIANT_MAPPINGS: Record<TypographyProps['tag'] & string, ElementType> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  p: 'p',
  caption: 'p',
};

export const Typography = ({
  tag = 'p',
  className,
  children,
  ...props
}: TypographyProps) => {

  const Component = VARIANT_MAPPINGS[tag];

  return (
    <Component className={cn('normal h-min', VARIANT_STYLES[tag], className)} {...props}>
      {children}
    </Component>
  );
}; 